export const CATEGORY_CONTENT = {
  iphone: {
    heading: "Lär känna din iPhone – i lugn takt",
    paragraphs: [
      "Vår manual för iPhone är skriven för dig som vill känna dig trygg med din telefon utan krångel och svåra ord. Vi förklarar allt steg för steg med stor text och tydliga bilder, precis som om vi satt bredvid dig. Du behöver inga förkunskaper – vi börjar från början och tar det i din egen takt.",
      "Många upplever att en ny iPhone känns svår i början: ikoner, appar, inställningar och uppdateringar kan vara förvirrande. Den här guiden gör tekniken begriplig. Du lär dig ringa och skicka meddelanden, ta och dela bilder, installera de appar du vill ha och hålla telefonen säker. Steg för steg bygger du upp ett självförtroende som gör vardagen enklare.",
    ],
    learnTitle: "Det här lär du dig",
    learn: [
      "Ringa, svara och lägga upp kontakter du använder ofta",
      "Skicka meddelanden, bilder och röstmeddelanden till familjen",
      "Ta, redigera och dela foton och videor",
      "Installera och ta bort appar från App Store på ett tryggt sätt",
      "Ställa in större text, ljusstyrka och ljud så att allt blir lättare",
      "Använda Face ID, lösenkod och säkerhetskopiering så att inget går förlorat",
    ],
    faqs: [
      { q: "Passar manualen för alla iPhone-modeller?", a: "Ja. Guiden fungerar för de flesta moderna iPhone-modeller eftersom stegen är desamma i grunden. Vi visar var det kan skilja sig lite mellan modeller." },
      { q: "Behöver jag vara van vid teknik?", a: "Nej. Manualen är gjord för nybörjare och seniorer. Vi förklarar varje steg med enkla ord och tydliga bilder." },
      { q: "Hur får jag manualen efter köp?", a: "Du får den direkt som en PDF till din e-post. Den kan läsas på mobil, surfplatta eller dator, och du kan skriva ut den om du vill." },
    ],
  },
  ipad: {
    heading: "Kom igång med din iPad",
    paragraphs: [
      "iPad är en av de enklaste och mest uppskattade surfplattorna – men bara när man vet hur den fungerar. Vår manual för iPad tar dig igenom allt du behöver, från att slå på plattan till att videosamtala med barnbarnen. Allt förklaras lugnt, med stor text och bilder som visar exakt var du ska trycka.",
      "Surfplattan är perfekt för att läsa nyheter, titta på film, spela spel och hålla kontakten. Med den här guiden slipper du gissa dig fram. Du lär dig grunderna och de smarta funktionerna som gör din iPad till ett roligt och användbart verktyg i vardagen.",
    ],
    learnTitle: "Det här lär du dig",
    learn: [
      "Starta, ladda och sköta din iPad på rätt sätt",
      "Surfa på internet och söka efter det du är nyfiken på",
      "Videosamtal med familj och vänner via FaceTime",
      "Titta på tv, film och YouTube på den stora skärmen",
      "Läsa e-post, tidningar och böcker med större text",
      "Hålla plattan uppdaterad och säker",
    ],
    faqs: [
      { q: "Är iPad svårare än en telefon?", a: "Nej, ofta tvärtom – den större skärmen gör allt tydligare och lättare att trycka rätt. Vår manual gör det ännu enklare." },
      { q: "Kan jag videosamtala med mina barnbarn?", a: "Absolut. Vi visar steg för steg hur du ringer och tar emot videosamtal, så att du kan se dina nära även på avstånd." },
      { q: "Hur levereras manualen?", a: "Som en PDF direkt till din e-post efter köp – att läsa på skärm eller skriva ut." },
    ],
  },
  macbook: {
    heading: "Förstå din MacBook",
    paragraphs: [
      "En MacBook är en kraftfull dator, men den fungerar lite annorlunda än en Windows-dator. Vår manual för MacBook förklarar allt på svenska med enkla ord: skrivbordet, mapparna, hur du sparar filer och hur du håller ordning. Du får en trygg grund att stå på, oavsett om datorn är ny eller om du haft den ett tag.",
      "Vi går igenom de vardagliga sakerna du faktiskt använder: e-post, internet, dokument, bilder och utskrifter. Du lär dig också de smarta genvägarna som gör att allt går snabbare. Steg för steg blir din MacBook enkel och rolig att använda.",
    ],
    learnTitle: "Det här lär du dig",
    learn: [
      "Hitta rätt på skrivbordet och i Finder (mapparna)",
      "Skriva, spara och organisera dokument och filer",
      "Läsa och skicka e-post samt surfa säkert på internet",
      "Överföra, sortera och dela dina bilder",
      "Ansluta skrivare, wifi och andra enheter",
      "Uppdatera, säkerhetskopiera och skydda datorn",
    ],
    faqs: [
      { q: "Jag har alltid haft Windows – går det ändå?", a: "Ja. Manualen är särskilt bra för dig som byter från Windows. Vi förklarar skillnaderna tydligt så att du snabbt känner dig hemma." },
      { q: "Passar guiden alla MacBook-modeller?", a: "Ja, grunderna är desamma för MacBook Air och MacBook Pro. Vi pekar ut de få ställen där det kan skilja sig." },
      { q: "Hur får jag tag på manualen?", a: "Du får en PDF direkt till din e-post efter köp och kan läsa den på valfri skärm eller skriva ut den." },
    ],
  },
  windows11: {
    heading: "Bli trygg med Windows 11",
    paragraphs: [
      "Windows 11 ser modernt ut men kan kännas ovant i början – särskilt om du är van vid en äldre dator. Vår manual för Windows 11 förklarar den nya startmenyn, aktivitetsfältet och inställningarna på ett lugnt och begripligt sätt. Med stor text och tydliga bilder visar vi exakt var du ska klicka.",
      "Du lär dig allt du behöver för vardagen: internet, e-post, dokument, bilder och utskrifter, samt hur du håller datorn snabb och säker. Steg för steg får du kontroll över din dator och slipper känna dig osäker.",
    ],
    learnTitle: "Det här lär du dig",
    learn: [
      "Använda den nya startmenyn och hitta dina program",
      "Surfa på internet och läsa e-post tryggt",
      "Skapa, spara och organisera dokument och mappar",
      "Överföra och sortera bilder från kamera och telefon",
      "Ansluta skrivare, wifi och andra enheter",
      "Hålla datorn uppdaterad, snabb och skyddad mot virus",
    ],
    faqs: [
      { q: "Jag har använt en äldre Windows – hänger jag med?", a: "Ja. Vi utgår från att du kanske är van vid en äldre version och förklarar tydligt vad som är nytt i Windows 11." },
      { q: "Är Windows 11 svårt?", a: "Nej, inte med rätt hjälp. Manualen bryter ner allt i små, enkla steg som är lätta att följa." },
      { q: "Hur levereras manualen?", a: "Direkt som en PDF till din e-post efter köp. Läs på mobil, surfplatta eller dator, eller skriv ut den." },
    ],
  },
};
